<script>
  import { Line, mixins } from 'vue-chartjs'

  export default {
    extends: Line,
    mixins: [mixins.reactiveProp],
    props:['chartData', 'color', 'titulo'],

    mounted () {
      var labels = this.chartData.labels;

      this.addPlugin({
        beforeUpdate(c){
          var ancho = c.chart.width;

          if(ancho<=90){

              if(c.scales["x-axis-0"].ticks===undefined){
                 c.scales["x-axis-0"].ticks = labels;
              }
                var largo = (Math.max(...(c.scales["x-axis-0"].ticks.map(el => el.length))) + 2)

                c.scales['x-axis-0'].options.ticks.minor.fontSize = ancho / largo;
                c.scales['y-axis-0'].options.ticks.minor.fontSize = ancho / largo;
                c.options.legend.labels.fontSize = ancho / largo;

                if(c.scales['x-axis-0'].options.ticks.minor.fontSize < 7){
                  c.scales['x-axis-0'].options.ticks.minor.fontSize = 7;
                  c.options.legend.labels.fontSize  = c.scales['y-axis-0'].options.ticks.minor.fontSize = 7;
                  c.scales["x-axis-0"].labelRotation = 90
                }
                if(c.scales['x-axis-0'].options.ticks.minor.fontSize > 16){
                  c.scales['x-axis-0'].options.ticks.minor.fontSize = 16;
                  c.options.legend.labels.fontSize  = c.scales['y-axis-0'].options.ticks.minor.fontSize = 16;
                }
              
          }
          
          c.options.legend.labels.boxWidth = c.options.legend.labels.fontSize;

        }
      });
      this.renderChart(this.chartData, {
        responsive: true, 
        spanGaps: true,
        maintainAspectRatio: false,
        legend:{
          labels:{
            fontColor: (this.color) ? 'white' : 'black',
            fontSize: 16,
            fontFamily:'Myriad'
          }
        }, 
        tooltips:{
          enabled: true,
          callbacks: {
            label : function(tooltipItem, data){
              let cantidad = parseFloat(tooltipItem.value).toLocaleString('en-US', {minimumFractionDigits: 2})
              let rubro = data.datasets[tooltipItem.datasetIndex].label + ': $' + cantidad;

              return rubro;
            }
          }
        },
        title:{
          display: true,
          text: this.titulo,
          fontColor: (this.color) ? 'white' : 'black',
          fontSize: 16,
          fontFamily:'Myriad'
        },
        animation:{
          duration: 0
        },
        onClick: this.enviarTabla,
        scales:{
          yAxes:[{
            ticks:{
              fontColor: (this.color) ? 'white' : 'black',
              fontSize: 14,
              fontFamily:'Myriad',
              beginAtZero: true
            }
          }],
          xAxes:[{
            ticks:{
              fontColor: (this.color) ? 'white' : 'black',
              fontSize: 14,
              fontFamily:'Myriad',
              autoSkip: true,
              maxTicksLimit: 10
            }
          }]
        }
      })
    },
    methods:{

      enviarTabla(p, e){

        var parametros = {
          fecha : this.chartData.labels[e[0]._index].split("/").reverse().join("-"),

          rubroId : this.chartData.datasets[0].rubroId,

          areaId : this.chartData.datasets[0].areaId

        }

        this.$emit('crearTabla', true, parametros)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/SIVAC/Reportes/Graficas/Linea.vue